import React from "react";
import "./grid.css";
import { AiFillStar } from "react-icons/ai";
import { BsBookmark } from "react-icons/bs";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { GoLocation } from "react-icons/go";
import { Link } from "react-router-dom";
import { baseUrl } from "../../context/BaseUrl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Courselogo = require("../../images/upsc.png");

const GridCourse = (props) => {
  const val = localStorage.getItem("user");
  const user = JSON.parse(val);
  const id = user.user._id;
  const token = user.token;
  // console.log(id);

  const BookMarked = async (value) => {
    try {
      const data = {
        object_id: props.id,
        user_id: id,
      };
      const response = await fetch(
        `${baseUrl}/user/user_rights/postbookmark/${id}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();

      if (result.code == 500) {
        toast.error(result.msg);
        return;
      }

      toast.success(result.msg);

      props.reload();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={`grid-card save-courses-mobile d-md-block ${
          props.dis ? "d-none" : "d-block"
        }`}
      >
        <div className="logo d-flex">
          <img src={Courselogo} alt="" />
          <div className="center">
            {/*<p>
              Rating 4.2 <span className="num">(1562)</span>{" "}
            </p>*/}
            <span>
              <AiFillStar /> <AiFillStar /> <AiFillStar /> <AiFillStar />
            </span>
          </div>
          <h6 onClick={() => BookMarked(props.id)}>
            {" "}
            <BsBookmark />
          </h6>
          <h6>
            {" "}
            <BiDotsVerticalRounded />
          </h6>
        </div>
        <h5 className="name">{props.detail.course}</h5>
        <p className="text-uppercase">{props.detail.medium}</p>
        <p className="p-abt text-uppercase">{props.detail.duration}</p>
        <div className="buttons d-md-flex d-none">
          {/* <button className='view'>View Courses</button> */}
          <button className="more">
            <Link to={`/course/${props.id}`}>Know More</Link>
          </button>
        </div>
      </div>
      <Link
        className="text-decoration-none text-black"
        to={`/course/${props.id}`}
      >
        <div
          className={`grid-card save-courses-mobile d-md-none ${
            props.detail.course ? props.detail.course : "d-none"
          }`}
        >
          <div className="logo d-flex">
            <img src={props.detail.icon} alt="akash" />
            <div className="center">
              <h5 className="name py-0">{props.detail.course}</h5>
              <p>
                Rating 4.2 <span className="num">(1562)</span>{" "}
              </p>
              <span>
                <AiFillStar /> <AiFillStar /> <AiFillStar /> <AiFillStar />
              </span>
            </div>
            <h6 onClick={() => BookMarked(props.id)}>
              {" "}
              <BsBookmark />
            </h6>
            <h6>
              {" "}
              <BiDotsVerticalRounded />
            </h6>
          </div>
          <p className="p-abt text-truncate vacancy-about">{props.detail.about}</p>
          <div className="buttons d-md-flex d-none">
            {/* <button className='view'>View Courses</button> */}
            <button className="more">
              <Link to={`/course/${props.id}`}>Know More</Link>
            </button>
          </div>
        </div>
      </Link>
    </>
  );
};

export default GridCourse;
